export const notesInitialState = {
	entities: {},
	totalToDisplay: 0,
	skip: 0,
};



// WEBPACK FOOTER //
// ./src/redux/notes/notes.initialState.js